<template>
    <div class="position-relative">
        <button class="nav-link nav-heart has-dark"
                rel="nofollow"
                @click="goToWatchlist"
        >
            {{ $t('Watchlist') }}
        </button>
        <span
            v-if="watchlistStore.count > 0"
            class="badge top-badge rounded-pill position-absolute top-0 start-100 translate-middle"
            :class="{'plus-100': watchlistStore.count > 100}"
            >
            {{ watchlistStore.count > 100000 ? '9999+' : watchlistStore.count }}
        </span>
    </div>
</template>

<script setup>
import { useWatchlistStore } from '~/stores/WatchlistStore';
import {useUserStore} from '~/stores/UserStore';
import {useModal} from '~/stores/ModalStore';
const WatchlistCreateAccountModal = defineAsyncComponent(() => import('~/components/Modals/WatchlistCreateAccountModal.vue'));
import { useLocalePath } from '#imports';

const localePath = useLocalePath();
const watchlistStore = useWatchlistStore();

const goToWatchlist = (e) => {
    if (!useUserStore().isLoggedIn()) {
        useModal().openModal('WatchlistCreateAccountModal', WatchlistCreateAccountModal);
        e.preventDefault();
        return;
    }

    useRouter().push(localePath({name: 'profile-watchlist'}) + '/');
};
</script>
